module.exports = __webpack_public_path__ + "static/img/phone.0edd7ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Home/phone.png
// module id = BBdQ
// module chunks = 7